import React from 'react';
import parse from 'html-react-parser';

import { PageSubHeader } from '../../../../components/layout/content';
import { getWildcardText } from '../../../../components/video';

import { HlReel, Shot } from '../../../../types';
import { getDuration, getFileUrl } from '../../../../utils';

import HlReelPreview from './hlReelPreview';

interface Props {
  hlReel: HlReel | null;
  requiredShots: Shot[];
  showVideo?: boolean;
}

const HlReelPreviewContainer: React.FC<Props> = (props) => {
  const { hlReel, requiredShots, showVideo } = props;

  return (
    <div className="w-full flex flex-col gap-4">
      <PageSubHeader
        heading="Highlight Reel"
        subheading={
          hlReel && (
            <>
              Here is a preview of your highlight reel. It is{' '}
              <b>{getDuration(hlReel.parameters.length)}</b> long with{' '}
              {parse(getWildcardText(requiredShots, 'wildcard spot'))}.
            </>
          )
        }
      />

      {showVideo && hlReel && (
        <video
          className="w-full sm:w-1/2 aspect-video rounded-md bg-black object-contain"
          src={getFileUrl(hlReel.parentElementId, hlReel.name, 'mp4')}
          poster={hlReel.thumbnailUrl}
          controls
        />
      )}

      <HlReelPreview hlReel={hlReel} />
    </div>
  );
};

export default HlReelPreviewContainer;
